<template>
  <div>
    <modal
      :name="name"
      :adaptive="true"
      height="auto"
      class="u-text-align-center"
      @closed="hide">
      <span
        v-if="crossCancelButton"
        style="display: flex; justify-content: right; padding: 4px;"
        class="close-button"
        @click="hide">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          x="0px"
          y="0px"
          width="20"
          height="20"
          viewBox="0,0,256,256">
          <g
            fill="#595959"
            fill-rule="nonzero"
            stroke="none"
            stroke-width="1"
            stroke-linecap="butt"
            stroke-linejoin="miter"
            stroke-miterlimit="10"
            stroke-dasharray=""
            stroke-dashoffset="0"
            font-family="none"
            font-weight="none"
            font-size="none"
            text-anchor="none"
            style="mix-blend-mode: normal">
            <g transform="scale(8.53333,8.53333)">
              <path
                d="M7,4c-0.25587,0 -0.51203,0.09747 -0.70703,0.29297l-2,
              2c-0.391,0.391 -0.391,1.02406 0,1.41406l7.29297,7.29297l-7.29297,
              7.29297c-0.391,0.391 -0.391,1.02406 0,1.41406l2,2c0.391,
              0.391 1.02406,0.391 1.41406,0l7.29297,-7.29297l7.29297,
              7.29297c0.39,0.391 1.02406,0.391 1.41406,0l2,-2c0.391,
              -0.391 0.391,-1.02406 0,-1.41406l-7.29297,-7.29297l7.29297,
              -7.29297c0.391,-0.39 0.391,-1.02406 0,-1.41406l-2,-2c-0.391,
              -0.391 -1.02406,-0.391 -1.41406,0l-7.29297,7.29297l-7.29297,
              -7.29297c-0.1955,-0.1955 -0.45116,-0.29297 -0.70703,-0.29297z">
              </path>
            </g>
          </g>
        </svg>
      </span>
      <div class="dialog-header">
        {{ title }}
      </div>
      <div class="dialog-body">
        <slot name="body" />
      </div>
      <div class="dialog-footer">
        <button
          v-if="defaultButtonTitle"
          :class="isHoverOnDefaultButton ?'c-btn c-btn--back hc-btn': 'c-btn'"
          @click.prevent="onDefaultClicked">
          {{ defaultButtonTitle }}
        </button>
        <button
          v-if="cancelButtonTitle"
          class="c-btn c-btn--back"
          @click.prevent="onCancelClicked">
          {{ cancelButtonTitle }}
        </button>
      </div>
    </modal>
  </div>
</template>
<script>

export default {
  name: 'ConfirmDialog',
  props: {
    name: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      default: '',
    },
    isShown: {
      type: Boolean,
      default: false,
    },
    defaultButtonTitle: {
      type: [String, Boolean],
      default: 'はい',
    },
    cancelButtonTitle: {
      type: [String, Boolean],
      default: 'いいえ',
    },
    crossCancelButton: {
      type: Boolean,
      default: false,
    },
    isHoverOnDefaultButton: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    isShown() {
      if (this.isShown) {
        this.show()
      } else {
        this.hide()
      }
    },
  },
  methods: {
    show() {
      this.$modal.show(this.name)
    },
    hide() {
      this.$modal.hide(this.name)
      this.$emit('closed')
    },
    onDefaultClicked() {
      this.$emit('default-clicked')
    },
    onCancelClicked() {
      this.$emit('cancel-clicked')
    },
  },
}
</script>

<style scoped>
.dialog-header {
  text-align: center;
  font-weight: bold;
  margin-top: 12px;
  /* height: 50px; */
  line-height: 50px;
  font-size: 20px;
}

.dialog-body {
  text-align: center;
  vertical-align: middle;
  height: auto;
  margin-top: 20px;
  margin-bottom: 20px;
}

.dialog-footer {
  text-align: center;
}

@media screen and (min-width: 896px) {
  .dialog-footer {
    margin-bottom: 20px;
  }
}
@media screen and (max-width: 895px) {
  .dialog-header {
    height: 20px;
    line-height: 20px;
    font-size: 20px;
  }
  .c-btn {
    display: block!important;
    width: 90%;
    margin: 0 auto 10px auto!important;
  }
}

.hc-btn:hover{
  background: #ff2289;
}
</style>
